var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDA44"
    },
    d: "M144.696,486.598C178.352,502.872,216.109,512,256,512s77.648-9.128,111.304-25.402L389.565,256 L367.304,25.402C333.648,9.128,295.891,0,256,0s-77.648,9.128-111.304,25.402L122.435,256L144.696,486.598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M367.304,486.589C452.935,445.183,512,357.493,512,256S452.935,66.817,367.304,25.411V486.589z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0052B4"
    },
    d: "M144.696,486.589V25.411C59.065,66.817,0,154.506,0,256S59.065,445.183,144.696,486.589z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M256,345.043c0-40.851,0-89.043,0-89.043h66.783v33.391c0,5.801-11.13,27.057-38.603,44.522 C273.775,340.529,263.004,342.657,256,345.043z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.217,
    y: 189.217,
    style: {
      fill: "#D80027"
    },
    width: 66.783,
    height: 66.783
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9811"
    },
    d: "M289.391,166.957c0-12.295-9.967-22.261-22.261-22.261c-4.06,0-7.854,1.104-11.13,3.002 c-3.277-1.898-7.07-3.002-11.13-3.002c-12.294,0-22.261,9.966-22.261,22.261h-55.652V278.26c0,41.436,32.906,65.399,58.711,77.821 c-1.931,3.298-3.059,7.125-3.059,11.224c0,12.295,9.967,22.261,22.261,22.261c4.06,0,7.854-1.104,11.13-3.002 c3.277,1.898,7.07,3.002,11.13,3.002c12.294,0,22.261-9.966,22.261-22.261c0-4.099-1.128-7.926-3.06-11.224 c25.805-12.422,58.712-36.384,58.712-77.821V166.957H289.391z M311.652,278.26c0,5.801,0,23.452-27.472,40.918 c-10.406,6.616-21.176,10.906-28.18,13.291c-7.004-2.385-17.774-6.675-28.18-13.291c-27.472-17.466-27.472-35.117-27.472-40.918 v-77.912h111.304V278.26z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAd);
export default __webpack_public_path__ + "static/media/ad.d0453350b18842fa1d5cecc04e40726d.svg";
export { ForwardRef as ReactComponent };